<div class="bg-color-white">
  <div fxLayout="row" class="u-padding-0-24" [ngStyle]="{ height: '48px' }">
    <app-form-template-title
      [text]="title.text"
      [primaryIcon]="title.primaryIcon"
      [secondaryIcon]="title.secondaryIcon"
      [ngStyle.gt-xs]="{ 'flex-grow': 1, 'flex-basis': 0 }"
      class="u-marginRight-16 u-display-block"
    >
    </app-form-template-title>
    <div [ngStyle]="{ 'flex-grow': 2, 'flex-basis': 0 }" fxLayout="row">
      <app-form-template-description
        [description]="description"
        class="u-width-100 color-grey-300 u-display-block"
      >
      </app-form-template-description>
      <app-form-template-header-action
        *ngIf="headerAction"
        [headerAction]="headerAction"
        class="u-display-block"
      >
      </app-form-template-header-action>
    </div>
  </div>
  <div
    *ngIf="disableForms || forms || actions"
    class="u-paddingTop-16 u-padding-0-24 u-paddingBottom-24"
  >
    <ng-container *ngIf="disableForms">
      <div class="u-marginBottom-16">
        <ng-container
          i18n="@@settingsView.cardPanel.disableFormsText"
          >{disableFormsText, select, other {{{ disableFormsText }}}
        }</ng-container>
      </div>
    </ng-container>
    <app-form-template-body
      *ngIf="forms && !disableForms"
      [formGroup]="formGroup"
      [forms]="forms"
      (formChange)="formChange($event)"
      class="u-display-block u-marginBottom-24"
    >
    </app-form-template-body>
    <ng-container *ngIf="actions && !disableActionBar">
      <div fxLayout="row" fxLayoutAlign="end center">
        <app-form-template-action-bar
          [actions]="actions"
          (itemClicked)="actionClick($event, formGroup)"
          class="u-display-block"
        >
        </app-form-template-action-bar>
      </div>
    </ng-container>
  </div>
</div>
